// src/components/ui/ProductCard.js
import React from 'react';

const ProductCard = ({ 
  title, 
  description, 
  itemCount, 
  image, 
  link, 
  category = "PRODUCT CARD"
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-soft hover:shadow-lg transition-all duration-300 overflow-hidden group">
      {/* Image Container */}
      <div className="relative h-48 bg-gray-200 overflow-hidden">
        {image ? (
          <img 
            src={image} 
            alt={title} 
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-100">
            <svg className="w-16 h-16 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
              <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"/>
            </svg>
          </div>
        )}
        
        {/* Item Count Badge */}
        {itemCount && (
          <div className="absolute bottom-3 right-3 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-medium text-brown">
            {itemCount} Items
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Category Label */}
        <div className="text-xs font-semibold text-primary mb-2 uppercase tracking-wide">
          {category}
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-brown mb-3 group-hover:text-primary transition-colors">
          {title}
        </h3>

        {/* Description */}
        <p className="text-brown-light text-sm mb-4 line-clamp-3">
          {description}
        </p>

        {/* CTA Link */}
        <a 
          href={link} 
          className="inline-flex items-center gap-2 text-primary font-medium text-sm hover:gap-3 transition-all group/link"
        >
          Show Categories
          <span className="text-lg">→</span>
        </a>
      </div>
    </div>
  );
};

export default ProductCard;

// Usage Example:
// <ProductCard 
//   title="Bread Improvers & Dough Conditioners"
//   description="Boost volume, improve texture, extend shelf-life, standardize batches—with zero guesswork."
//   itemCount={12}
//   image="https://images.unsplash.com/photo-1509440159596-0249088772ff"
//   link="/products/bread-improvers"
//   category="INGREDIENTS"
// />